import classnames from 'classnames';
import { SomethingWrongIcon as somethingWrongIcon, NormalButton } from '@/shared/ui';
import useFallbackError from './useFallbackError';
import './styles.scss';

export type FallbackErrorProps = {
  error?: any;
  resetErrorBoundary: () => void;
  isShowTabHeader?: boolean;
};

/**
 * Error boundary fallback shown when a report tab crashes. Renders the something-went-wrong illustration, a reload prompt and a button calling the hook's reset handler, tightening its layout when the tab header is hidden.
 *
 * @param props - The fallback props, including isShowTabHeader which adjusts the layout.
 * @returns The rendered fallback panel with its reload button.
 */
const FallbackError = ({ error, resetErrorBoundary, isShowTabHeader }: FallbackErrorProps) => {
  const { onClickReset } = useFallbackError({ error, resetErrorBoundary });

  return (
    <div className={classnames('fallback-error', isShowTabHeader ? '' : '--hide-tab')}>
      <img src={somethingWrongIcon} alt="something went wrong" />
      <div className="fallback-text">
        Oops, looks like something went wrong. <br />
        Please reload the tab.
      </div>
      <NormalButton className="reload-now-btn" buttonName="Reload Now" onClick={onClickReset} />
    </div>
  );
};

export default FallbackError;
